import { ReactComponent as Dashboard } from 'assets/icons/icon-dashboard.svg';

export default Dashboard;
